import { useTranslations } from 'next-intl'

import { cn, useFormatCurrency } from '@/shared/lib'

import { TRoomDetail } from '../../model/schema'

export type Props = Pick<
  TRoomDetail,
  | 'roomName'
  | 'roomCnt'
  | 'bathroomCnt'
  | 'sittingroomCnt'
  | 'cookroomCnt'
  | 'usingFee'
  | 'mgmtFee'
> & {
  propertyType: string
  province: string
  town: string
  size: 'small' | 'large'
}

export const Overview = ({
  size,
  province,
  town,
  propertyType,
  roomName,
  roomCnt,
  bathroomCnt,
  sittingroomCnt,
  cookroomCnt,
  usingFee,
  mgmtFee,
}: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  return (
    <>
      <div className="mb-[6px] space-y-1">
        <h3
          className={cn('line-clamp-1 font-semibold text-gray-900', {
            'typo-body2': size === 'small',
            'typo-body1': size === 'large',
          })}
        >
          {t('search_panel.recent_room.roomName', {
            address: `${province} ${town}`,
            propertyType,
          })}
        </h3>
        <p className="typo-label1 line-clamp-1 font-normal text-gray-900">
          {roomName}
        </p>
        <div className="typo-label1 flex gap-2 font-normal text-gray-500">
          {roomCnt > 0 && (
            <p className="space-x-px">
              <span>{t('common.br')}</span>
              <span className="text-gray-900">{roomCnt}</span>
            </p>
          )}
          {bathroomCnt > 0 && (
            <p className="space-x-px">
              <span>{t('common.ba')}</span>
              <span className="text-gray-900">{bathroomCnt}</span>
            </p>
          )}
          {cookroomCnt > 0 && (
            <p className="space-x-px">
              <span>{t('common.kit')}</span>
              <span className="text-gray-900">{cookroomCnt}</span>
            </p>
          )}
          {sittingroomCnt > 0 && (
            <p className="space-x-px">
              <span>{t('common.lr')}</span>
              <span className="text-gray-900">{sittingroomCnt}</span>
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center gap-1 [&:not(:last-child)]:mb-[4px]">
        <p className="typo-headline3 flex items-center gap-0.5 font-bold text-gray-900">
          {formatCurrency(usingFee + mgmtFee, {
            unit: chunks => (
              <span className="typo-label1 font-bold">{chunks}</span>
            ),
          })}
        </p>
        <span className="typo-body1-reading font-light text-gray-200">/</span>
        <span className="typo-body1 font-bold text-purple-500">
          {t('common.week_unit')}
        </span>
      </div>
    </>
  )
}
